/* eslint-disable react/jsx-no-target-blank */
import React from "react";
import { string } from "prop-types";
// eslint-disable-next-line import/no-cycle
import { SocialFollowButtonsCTA as SocialFollowButtonsCTAComponent } from "../../../sharedComponents/SocialFollowButtons";
import * as styles from "./SocialFollowButtonsCTA.module.scss";

const SocialFollowButtonsCTA = ({
	ctaTitle,
	facebookPageLink,
	instagramPageLink,
	twitterPageLink,
	pinterestPageLink,
	youTubePageLink,
}) => (
	<SocialFollowButtonsCTAComponent
		ctaTitle={ctaTitle}
		facebookPageLink={facebookPageLink}
		instagramPageLink={instagramPageLink}
		twitterPageLink={twitterPageLink}
		pinterestPageLink={pinterestPageLink}
		youTubePageLink={youTubePageLink}
		styles={styles}
	/>
);

SocialFollowButtonsCTA.propTypes = {
	ctaTitle: string,
	facebookPageLink: string,
	instagramPageLink: string,
	twitterPageLink: string,
	pinterestPageLink: string,
	youTubePageLink: string,
};
SocialFollowButtonsCTA.defaultProps = {
	ctaTitle: null,
	facebookPageLink: null,
	instagramPageLink: null,
	twitterPageLink: null,
	pinterestPageLink: null,
	youTubePageLink: null,
};

export default SocialFollowButtonsCTA;
export { SocialFollowButtonsCTA };
